var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme'; // import { Icon, Icons, SliceLayoutBoundary, classNames, useSite } from '@shapeable/web';

import { Icon } from './icon';
import { Icons } from '../icons';
import { SliceLayoutBoundary } from '../entities/slice-layout';
import { classNames } from '../../utils/cn';
import { useSite } from '../../hooks/use-site';
import { SiteHeaderLogo } from '../entities/site-header-logo';
import { useSiteSidebar } from '../../hooks/use-site-sidebar';
import { SiteMenuSidebar } from '../entities/site-menu-sidebar';
var cls = classNames('menu-mobile');
export var MenuRevealDefaultProps = {
  variant: 'default',
  isInverted: true,
  showSidebar: false
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    left: 0;\n    max-height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-sizing: border-box;\n    z-index: 400;\n    width: 100%;\n    padding-bottom: ", ";\n    background:rgba(0, 0, 0, 0.95);\n  "], ["\n    position: fixed;\n    left: 0;\n    max-height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-sizing: border-box;\n    z-index: 400;\n    width: 100%;\n    padding-bottom: ", ";\n    background:rgba(0, 0, 0, 0.95);\n  "])), theme.UNIT(1)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var hasSidebar = _a.hasSidebar,
        sidebarWidth = _a.sidebarWidth;
    return hasSidebar && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: calc(100% - ", "px);\n    "], ["\n      width: calc(100% - ", "px);\n    "])), sidebarWidth);
  }),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var LogoStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    ", "\n  "])), function (_a) {
    var heightMobile = _a.heightMobile;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightMobile);
  }),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightTablet = _a.heightTablet,
        variant = _a.variant;
    return variant === 'default' && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightTablet);
  }),
  desktop: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var heightDesktop = _a.heightDesktop,
        variant = _a.variant;
    return variant === 'default' && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), heightDesktop);
  })
});
var CloseButtonStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n\n  "], ["\n    cursor: pointer;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n\n  "])), function (_a) {
    var showSidebar = _a.showSidebar;
    return showSidebar && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: block;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n  "], ["\n    display: block;\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    ", "\n  "])), function (_a) {
    var variant = _a.variant;
    return variant === 'default' && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), theme.UNIT(3));
  })
});
var SidebarStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n  "], ["\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n  "]))),
  tablet: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    width: 100%;\n\n    ", "\n  "], ["\n    width: 100%;\n\n    ", "\n  "])), function (_a) {
    var sidebarWidth = _a.sidebarWidth;
    return sidebarWidth && css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      width: calc(100% - ", "px);\n    "], ["\n      width: calc(100% - ", "px);\n    "])), sidebarWidth);
  }),
  tablet: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Logo: styled(SiteHeaderLogo)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  CloseButton: styled(Icon)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Sidebar: styled(SiteMenuSidebar)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), SidebarStyles)
};
/* @ts-ignore */

export var MenuReveal = React.forwardRef(function (props, ref) {
  var className = props.className,
      isInverted = props.isInverted,
      onCloseClick = props.onCloseClick,
      variant = props.variant,
      children = props.children;

  var _a = useSite(),
      headerHeightMobile = _a.headerHeightMobile,
      headerHeightTablet = _a.headerHeightTablet,
      headerHeightDesktop = _a.headerHeightDesktop;

  var sidebar = useSiteSidebar();
  var showSidebar = props.showSidebar && sidebar.isAvailable;
  return React.createElement(My.Container, {
    hasSidebar: sidebar.isAvailable,
    sidebarWidth: sidebar.width,
    ref: ref,
    className: cls.name(className)
  }, React.createElement(My.Body, {
    sidebarWidth: showSidebar ? sidebar.widthMenu : 0
  }, React.createElement(SliceLayoutBoundary, null, React.createElement(My.Header, {
    variant: variant,
    heightMobile: headerHeightMobile,
    heightTablet: headerHeightTablet,
    heightDesktop: headerHeightDesktop
  }, React.createElement(My.Logo, {
    sizeVariant: variant,
    isInverted: isInverted
  }), React.createElement(My.CloseButton, {
    showSidebar: showSidebar,
    variant: variant,
    onClick: onCloseClick,
    color: isInverted ? 'light' : 'dark'
  }, React.createElement(Icons.CrossCircle, null)))), children), showSidebar && React.createElement(My.Sidebar, {
    onCloseClick: onCloseClick
  }));
});
MenuReveal.cls = cls;
MenuReveal.defaultProps = MenuRevealDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;